import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import Grinding from "./ProcessingSubforms/grinding";
import Sifting from "./ProcessingSubforms/sifting";
import Drying from "./ProcessingSubforms/drying/drying";
import Calcination from "./ProcessingSubforms/calcination/calcination";
import Digestion from "./ProcessingSubforms/digestion";
import NotApplicableProcessing from "./ProcessingSubforms/not_applicable_processing";
import Evaporation from "./ProcessingSubforms/evaporation";
import Chipping from "./ProcessingSubforms/chipping";
import {
  EnumProcessingOption,
  processingTablesDisabledFalse,
  processingTablesDisabledTrue,
} from "@app/utils/tables/processing.tables";
import { MCheckbox, ResponsiveFormContainer } from "@app/components";
import { useSample } from "../../utils/useSample";
import ErrorMessage from "@app/utils/ErrorMessage";
import { analysis_processing } from "../../config/phases/AnalysisPhases";

type ProcessingOption =
  | "grinding"
  | "sifting"
  | "drying"
  | "calcination"
  | "evaporation"
  | "digestion"
  | "chipping"
  | "not_applicable";

const componentsForm: Record<ProcessingOption, React.ComponentType> = {
  grinding: Grinding,
  sifting: Sifting,
  drying: Drying,
  calcination: Calcination,
  evaporation: Evaporation,
  digestion: Digestion,
  chipping: Chipping,
  not_applicable: NotApplicableProcessing,
};

const Processing: React.FC = () => {
  const form = useFormContext();
  const { stateSample } = useSample();
  const [selectedOptions, setSelectedOptions] = useState<ProcessingOption[]>(
    []
  );

  function hasConditioningMatch(apiArray, conditions) {
    return apiArray
      ? apiArray.some((item) => conditions.includes(item.codigo))
      : false;
  }

  const setConditioningTables = () => {
    return hasConditioningMatch(
      form.getValues("analysis_type"),
      analysis_processing
    )
      ? processingTablesDisabledFalse
      : processingTablesDisabledTrue;
  };

  const processingSelect: ProcessingOption[] = form.watch(
    "processing_category",
    []
  ) as ProcessingOption[];

  useEffect(() => {
    const newSelection = processingSelect.filter(
      (option) => !selectedOptions.includes(option)
    )?.[0];

    if (newSelection === EnumProcessingOption.NOT_APPLICABLE) {
      form.setValue("processing_category", [
        EnumProcessingOption.NOT_APPLICABLE,
      ]);
      setSelectedOptions([EnumProcessingOption.NOT_APPLICABLE]);
    } else if (processingSelect.includes(EnumProcessingOption.NOT_APPLICABLE)) {
      const filteredSelections = processingSelect.filter(
        (option) => option !== EnumProcessingOption.NOT_APPLICABLE
      );
      setSelectedOptions(filteredSelections);
      form.setValue("processing_category", filteredSelections);
    } else {
      setSelectedOptions(processingSelect);
    }
  }, [JSON.stringify(processingSelect)]);

  return (
    <>
      {stateSample.conditioning.isSave ? (
        <ResponsiveFormContainer columns={1} mt={1}>
          <MCheckbox
            name="processing_category"
            options={setConditioningTables()}
            validation={{ required: "Debe seleccionar al menos una opción" }}
            multiple={true}
            orientation="horizontal"
            columns={8}
          />

          {processingSelect?.map((option) => {
            const SelectedComponent = componentsForm[option];
            return SelectedComponent && <SelectedComponent key={option} />;
          })}
        </ResponsiveFormContainer>
      ) : (
        <ErrorMessage />
      )}
    </>
  );
};

export default Processing;
